/** Pure Presence scene-token conversions shared by Scenes and Flows. */
export function deviceZoneIdToSceneZoneId(deviceZoneId: string | number): string {
	const numericId = typeof deviceZoneId === 'string' ? parseInt(deviceZoneId, 10) : deviceZoneId;
	return (numericId + 1).toString();
}

export function sceneZoneIdToDeviceZoneId(sceneZoneId: string | number): string {
	const numericId = typeof sceneZoneId === 'string' ? parseInt(sceneZoneId, 10) : sceneZoneId;
	return (numericId - 1).toString();
}

export function extractZoneIdFromPresenceCondition(conditionName: string): string | null {
	const match = conditionName.match(/^prsn_(?:st|nobj_d|nobj)4(\d{3})$/);
	return match?.[1] ? sceneZoneIdToDeviceZoneId(match[1]) : null;
}

export function buildPresenceConditionName(
	conditionType: 'st' | 'nobj' | 'nobj_d',
	deviceZoneId: string | number,
): string {
	return `prsn_${conditionType}4${deviceZoneIdToSceneZoneId(deviceZoneId)}`;
}

export function isPresenceZoneCondition(conditionName: string): boolean {
	return /^prsn_(?:st|nobj_d|nobj)4\d{3}$/.test(conditionName);
}

export function getPresenceConditionType(
	conditionName: string,
): 'state' | 'object_count' | 'delta' | null {
	if (conditionName.startsWith('prsn_st4')) return 'state';
	if (conditionName.startsWith('prsn_nobj_d4')) return 'delta';
	if (conditionName.startsWith('prsn_nobj4')) return 'object_count';
	return null;
}
